/**
 * @generated SignedSource<<bfe3bdec0f7d01f930d429a8f7524454>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "feedIds"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "DisruptionInfoButton_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "feeds",
          "variableName": "feedIds"
        }
      ],
      "concreteType": "Alert",
      "kind": "LinkedField",
      "name": "alerts",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueryType",
  "abstractKey": null
};

node.hash = "75949675948e62b8f3604c421661c084";

export default node;
